import {
  login,
  logout
} from '@/api/login'
import {
  getToken,
  setToken,
  removeToken
} from '@/utils/auth'
import router from "../../router/index";
import GLOBAL from '@/api/global/globalVariable.js'
const user = {
  state: {
    token: getToken(),
    // username: '',
    // avatar: '',
    //暂时写个固定的
    username: "",
    // avatar: 'http://static.coderak.top/webdoc/311ad9ec2e9c1f5a907269eea6146119a67677703805-viW0M2_fw658.webp',
    avatar: '',
    roles: []
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_NAME: (state, username) => {
      state.username = username
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    }
  },

  actions: {
    // 登录
    Login({
      commit
    }, userInfo) {
      const username = userInfo.username.trim()
      return new Promise((resolve, reject) => {
        login(username, userInfo.password).then(response => {
          const data = response.data
          const tokenStr = data.tokenHead + data.token
          this.state.username = response.data.data.username
          // GLOBAL.setName(this.state.username);
          //console.log(sessionStorage .getItem("username"));
          sessionStorage .removeItem("username");
          //console.log(sessionStorage .getItem("username"));
          sessionStorage .setItem("username", this.state.username);
          //console.log(sessionStorage .getItem("username"));
          setToken(tokenStr)
          commit('SET_TOKEN', tokenStr)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 获取用户信息
    GetInfo({
      commit,
      state
    }) {
      return new Promise((resolve, reject) => {
        getInfo().then(response => {
          const data = response.data
          if (data.roles && data.roles.length > 0) { // 验证返回的roles是否是一个非空数组
            commit('SET_ROLES', data.roles)
          } else {
            reject('getInfo: roles must be a non-null array !')
          }
          commit('SET_NAME', data.username)
          commit('SET_AVATAR', data.icon)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 登出
    LogOut({
      commit,
      state
    }) {
      return new Promise((resolve, reject) => {
        logout(state.token).then(() => {
          commit('SET_TOKEN', '')
          commit('SET_ROLES', [])
          removeToken()
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 前端 登出
    FedLogOut({
      commit
    }) {
      return new Promise(resolve => {
        //router.push({path: `/login`,});
        window.location.href = "/login";
      })
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js